import { useLocation, Navigate, Outlet } from "react-router-dom";
// import useAuth from "./useAuth";

const AdminRoute = () => {
  // const { auth } = useAuth();
  const token = localStorage.getItem("jwtToken");
  const userData = JSON.parse(localStorage.getItem("user"));

  const location = useLocation();
  return token && userData.isSuperAdmin ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard" state={{ from: location }} replace />
  );
};

export default AdminRoute;
